Sets the disabled features for a hiring organization.

This allows partners to disable specific features for a hirer that would otherwise be available based on their relationship types.

Currently, one feature code is defined:

- `CandidateVerification` disables the Verify with SEEK Pass functionality for the hirer.

This mutation accepts tokens that include the `mutate:candidate-verification` scope.
